// src/utils/permissoes.js

/**
 * É administrador?
 *
 * Mesmo critério do servidor (server/middleware/requireAdmin.js): o JWT traz
 * isAdmin, vindo de users.is_admin, e alguns tokens antigos trazem role.
 *
 * Isto serve só para o ecrã não oferecer botões que o servidor vai recusar. A
 * permissão real é a de lá — esconder um botão não protege nada.
 */
export function ehAdmin(user) {
  return user?.isAdmin === true || user?.role === 'admin';
}
